import LoginRouteLayout from "./LoginRouteLayout";

export default LoginRouteLayout;
